import React from 'react';
import styled from 'styled-components';

const StyledInput = styled.input`
  display: flex;
  height: 40px;
  width: 320px;
  line-height: 40px;
  color: #000;
  background-color: #FFF;
  font-size: 1rem;
  height: 60px;
  padding-left: 40px;
  padding-right: 40px;
  border-width: 1px;
  border-color: #D7D7D7;
  border-style: solid;
  border-radius: 10px;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.19);
  
  ::-webkit-input-placeholder {
   text-align: center;
  }
  
  :-moz-placeholder { /* Firefox 18- */
     text-align: center;  
  }
  
  ::-moz-placeholder {  /* Firefox 19+ */
     text-align: center;  
  }
  
  :-ms-input-placeholder {  
     text-align: center; 
  }

  box-shadow: 1px 2px #666;
   &:hover {
  } 
  
  @media (max-width: 1023px) {
    width: 300px;
  }
  @media (max-width: 600px) {
    width: 220px;
    padding-left: 20px;
    padding-right: 20px;
  }
  
   ${props => props.styles }
`;


const TextField = (props) => (
    <StyledInput
      currency={props.currency}
      type={props.type}
      placeholder={props.placeholder}
      {...props}>
      {props.children}
    </StyledInput>);

export default TextField;


// WEBPACK FOOTER //
// ./src/Components/TextField.js